import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M1 2h5v20H1zm14.5 15a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const brandEcommercePatreon = { render };
export {
  brandEcommercePatreon as default,
  render
};
//# sourceMappingURL=brand-ecommerce-patreon.svg.js.map
